import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

// Models:
import type { IBreadCrumbs } from '../../../data/models/header/breadcrumb.model';

interface Props {
  breadcrumbs?: IBreadCrumbs[];
  isMobile?: boolean;
}

export const Breadcrumbs: FC<Props> = (props) => {
  const { breadcrumbs = [], isMobile = false } = props;
  const { length } = breadcrumbs;

  return (
    <StyledContainer>
      <StyledShadow isMobile={isMobile} />
      <StyleList itemScope itemType="https://schema.org/BreadcrumbList">
        {breadcrumbs.map((crumb, index) => {
          const { text, link } = crumb;
          const divider = index !== length - 1 ? ',' : '';
          const isLast = index === breadcrumbs.length - 1;
          const anchorText = typeof text === 'string' ? text + divider : '';
          return (
            <StyledElem
              key={text}
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              {isLast ? (
                <StyledLastChild itemProp="name">{anchorText}</StyledLastChild>
              ) : (
                <StyledAnchor itemProp="item" href={link}>
                  <span itemProp="name">{anchorText}</span>
                </StyledAnchor>
              )}
              <meta itemProp="position" content={String(index)} />
            </StyledElem>
          );
        })}
      </StyleList>
    </StyledContainer>
  );
};

const StyleList = styled.ol`
  white-space: nowrap;
  overflow-x: scroll;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* Hide scrollbar on IE and Edge */
  scrollbar-width: none; /* Hide scrollbar on Firefox */
`;

const StyledElem = styled.li`
  font-size: 14px;
  line-height: 16px;
  display: inline-block;

  &:not(:last-child) {
    margin-right: 3px;
  }
`;

const StyledAnchor = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.blue};
`;

const StyledLastChild = styled.span`
  color: #000;
  margin-right: 30px;
`;

const StyledContainer = styled.div`
  position: relative;
`;

const StyledShadow = styled.div<{ isMobile: boolean }>`
  position: absolute;
  height: 16px;
  width: 30px;
  right: -1px;
`;
